"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "scarperia-e-san-piero": {
    "944100ba": [{
      "hkey": "516a92c7",
      "slug": "scarperia-e-san-piero",
      "name": "Scarperia e San Piero",
      "primary": true,
      "skipSearch": false
    }],
    "lucigliaio": [{
      "hkey": "516a92c7",
      "slug": "scarperia-e-san-piero",
      "name": "Scarperia e San Piero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1916683a": [{
      "hkey": "a9a362ea",
      "slug": "campomigliaio",
      "name": "Campomigliaio",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano-a-cornetole": [{
      "hkey": "a9a362ea",
      "slug": "campomigliaio",
      "name": "Campomigliaio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "scarperia-e-san-piero"
    }]
  }
};
exports["default"] = _default;